module.exports = __webpack_public_path__ + "static/media/oneplus-hp.3ea0889e.png";